import React from 'react';
import ErrorBoundary from 'dc/ErrorBoundary';
import { useConfig, useText } from 'common/hooks';

type Props = {
  readonly children?: React.ReactNode;
};

export default function ChallengeErrorBoundary({
  children,
}: Props): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  return (
    <ErrorBoundary
      title={t('appContainer.error_boundary.title')}
      body={t('appContainer.error_boundary.body')}
      buttonText={t('appContainer.error_boundary.button_text')}
      imageSrc={`${staticUrl}/images/trophy_investigate.svg`}
    >
      {children}
    </ErrorBoundary>
  );
}
